import { Dialog, DialogContent, Box, Stack } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import CameraIcon from '@mui/icons-material/Camera';
import AutorenewIcon from '@mui/icons-material/Autorenew';

const CameraModal = ({ open, onClose, onCapture }) => {
    const videoRef = useRef(null);
    const canvasRef = useRef(null);

    const [stream, setStream] = useState(null);
    const [facingMode, setFacingMode] = useState("environment"); 
    useEffect(() => {
        if (open) startCamera();

        return () => stopCamera();
        // eslint-disable-next-line
    }, [open, facingMode]);

    const startCamera = async () => {
        stopCamera();

        try {
        const mediaStream = await navigator.mediaDevices.getUserMedia({
            video: { facingMode },
            audio: false
        });

        setStream(mediaStream);
        if (videoRef.current) {
            videoRef.current.srcObject = mediaStream;
        }
        } catch (err) {
        console.error("Camera error:", err);
        }
    };

    const stopCamera = () => {
        if (stream) {
        stream.getTracks().forEach(track => track.stop());
        setStream(null);
        }
    };

    const handleFlip = () => {
        setFacingMode(prev =>
        prev === "user" ? "environment" : "user"
        );
    };

    const handleCapture = () => {
        const video = videoRef.current;
        const canvas = canvasRef.current;

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0);

        const imageBase64 = canvas.toDataURL("image/png");

        onCapture(imageBase64);
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose}>
        <DialogContent sx={{ p: 0 }}>
            <Box
            position="relative"
            width="100%"
            bgcolor="#000"
            borderRadius={2}
            overflow="hidden"
            >
            <video
                ref={videoRef}
                autoPlay
                playsInline
                style={{
                width: "100%",
                height: "auto",
                display: "block"
                }}
            />

            <canvas ref={canvasRef} hidden />

            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                position="absolute"
                bottom={0}
                left={0}
                right={0}
                zIndex={2}
                px={2}
                py={1.5}
                sx={{
                    background: "linear-gradient(to top, rgba(0,0,0,0.7), rgba(0,0,0,0))"
                }}
            >
                <Box onClick={handleFlip} sx={{ cursor: "pointer" }}>
                <AutorenewIcon sx={{ fontSize: 40, color: "#fff" }} />
                </Box>

                <Box onClick={handleCapture} sx={{ cursor: "pointer" }}>
                <CameraIcon sx={{ fontSize: 56, color: "#fff" }} />
                </Box>

                <Box width={40} />
            </Stack>
            </Box>
        </DialogContent>
        </Dialog>

    );
}; 

export default CameraModal;
